import { getLocale } from "../runtime";

const sv_searchresultsother = /** @type {(inputs: {value: NonNullable<unknown>}) => string} */ (inputs) => {
	return `Visa alla ${inputs.value} resultat`
};

const searchresultsother = /** @type {(inputs: {value: NonNullable<unknown>}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_searchresultsother(inputs)
	return "searchResultsOther";
};

export { searchresultsother as "searchResultsOther" };